import { Header as StrataHeader } from '@strata/react-header';

export const Header = () => (
    <StrataHeader showProfileDropdown={false} fmhEnvironmentForTag={process.env.REACT_APP_ENV} />
);
